import React from 'react';
import styled from 'styled-components';
import { convertHexToRGBA, KeyboardCodes, ModuleBarSkins } from '../Helpers';
import GlobalStyle from '../Theme/GlobalStyle';

const StyledLauncher = styled.button`
    background: ${props => props.backgroundColor} !important;
    border: none;
    border-radius: 4px;
    box-sizing: border-box;
    color: ${props => props.textColor} !important;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-family: 'Gilroy', sans-serif !important;
    font-size: 14px !important;
    line-height: 1 !important;
    height: ${props => props.launcherHeight};
    margin: 2px;
    padding: 0 8px;
    cursor: pointer;
    position: ${props => props.position};
    text-align: center;
    min-width: ${props => props.launcherWidth}px !important;
    ${props => props.skin === ModuleBarSkins.WALLET? '' : `max-wdith: ${props => props.launcherWidth}px !important;` }

    ::after,
    ::before {
        content: '' !important;
        display: none !important;
    }

    svg {
        margin: ${props => (props.size === 'medium' ? '0 4px 0 0' : '0 0 4px')};
        height: 16px;
        width: 16px;
    }

    &.wallet {
        flex-direction: row;
        font-size: 16px;
        font-weight: 800;
        justify-content: flex-start;
        margin: 0;
        text-align: left;
        width: 100%;
        ${props => props.zIndex}

        .clx-module__launcher-icon {
            background-color: ${props => convertHexToRGBA(props.iconColor, 8)};
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
            width: 32px;
            height: 32px;

            svg {
                height: 16px;
                width: 16 px;
            }
        }

        .clx-module__launcher-caret {
            margin-left: auto;
            height: 16px;
            widht: 16px;
        }
    }
`;

const Launcher = ({
    backgroundColor,
    height,
    icon,
    item,
    mode,
    onClick,
    onKeyDown,
    order,
    size,
    skin,
    textColor,
    title,
    width
}) => {
    let launcherHeight = `${height}px`;
    let launcherBackgroundColor =
        mode === 'dark' ? convertHexToRGBA('#ffffff', 8) : convertHexToRGBA(backgroundColor, 16);
    let launcherTextColor = mode === 'dark' ? textColor : backgroundColor;
    let launcherFlexDirection = size !== 'large' ? 'row' : 'column';
    let launcherPosition = skin === ModuleBarSkins.WALLET ? 'absolute' : 'relative';
    const launcherZIndex = skin === ModuleBarSkins.WALLET ? (order == 1 ? 'z-index: 1;' : 'z-index: -1;') : '';

    const handleKeyDown = (e, item, onKeyDown) => {
        if ([KeyboardCodes.ENTER, KeyboardCodes.SPACE].includes(e.keyCode)) {
            onKeyDown(item);
        }
    };

    // Note: As we add more skins, we need to move this to a more robust theming approach;
    if (skin === ModuleBarSkins.WALLET) {
        launcherHeight = '64px';
        launcherBackgroundColor = '#ffffff';
        launcherTextColor = '#181818';
        launcherFlexDirection = 'row';
    }

    return (
        <>
            <GlobalStyle />
            <StyledLauncher
                backgroundColor={launcherBackgroundColor}
                className={`clx-module__launcher ${skin === ModuleBarSkins.WALLET ? 'wallet' : ''}`}
                flex={launcherFlexDirection}
                iconColor={backgroundColor}
                launcherHeight={launcherHeight}
                launcherWidth={width}
                onClick={() => onClick(item)}
                onKeyDown={e => handleKeyDown(e, item, onKeyDown)}
                size={size}
                tabIndex="0"
                textColor={launcherTextColor}
                position={launcherPosition}
                zIndex={launcherZIndex}
                skin={skin}
            >
                <span className="clx-module__launcher-icon">{icon}</span>
                <span className="clx-module__launcher-title">{title}</span>
                {skin === ModuleBarSkins.WALLET && (
                    <svg
                        className="clx-module__launcher-caret"
                        width="9"
                        height="15"
                        viewBox="0 0 9 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1.73813 2.21875L6.99048 7.45312L1.73813 12.6875"
                            stroke="#B9BABC"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                )}
            </StyledLauncher>
        </>
    );
};

export default Launcher;
